const addTouchedClass = event => {
	const el = event.target;
	el.classList.add('touched');

	el.removeEventListener('change', addTouchedClass);
	el.removeEventListener('keyup', addTouchedClass);
};

module.exports = {
	/**
	 * Adds a 'touched' class on an input's change or keyup event
	 */
	bind(el) {
		el.addEventListener('change', addTouchedClass);
		el.addEventListener('keyup', addTouchedClass);
	},

	/**
	 * Removes the click handler from the element as Vue.js unbinds the directive
	 */
	unbind(el) {
		el.removeEventListener('change', addTouchedClass);
		el.removeEventListener('keyup', addTouchedClass);
	}
};
